export default {
    'name': 'no-file',
    'width': '88',
    'height': '76',
    'viewBox': '0 0 76 88',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M0 23.2409V80H71.1111V0H22.4796L0 23.2409Z\' fill=\'#006CFD\'/><path d=\'M36 45L44.8744 73L52.1778 61.1778L63.9976 53.8768L36 45Z\' fill=\'#C1E8FD\'/><path d=\'M51.9499 55.3391L46.3362 60.9528L57.9485 72.5651L63.5622 66.9515L51.9499 55.3391Z\' fill=\'#C1E8FD\'/>'
}
